'use es6';

import http from 'hub-http/clients/apiClient';
import getLang from 'I18n/utils/getLang';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getCssAssetsUrl } from 'ContentEditorUI/lib/scalableEditor/commonFeatureConfigs';
import getEarlyRequesterResultPromise from '../earlyRequester/getEarlyRequesterResultPromise';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { trackAppLifecycleTimestamp, COMBINED_EDIT_REQUEST_STARTED, COMBINED_EDIT_REQUEST_FINISHED } from 'ContentEditorUI/utils/lifecycleData';
function getIsUniversalThemeEditorEnabled() {
  return EditorConfigSingleton.getFeatureFlagOrDefault(FEATURE_FLAGS.universalThemeEditor, false);
}
function getIsStagingV2Enabled() {
  const store = window.hubspot.ContentEditorUI.store;
  return store ? getIsStagingV2(store.getState()) : false;
}
function getUrl(id, includeUsedModuleSchemas) {
  const language = getLang();
  let url = includeUsedModuleSchemas ? `content-editor/v1/combined-edit-data/${id}?includeUsedModuleSchemas=true&userLanguage=${language}` : `content-editor/v1/combined-edit-data/${id}?userLanguage=${language}`;
  if (getIsUniversalThemeEditorEnabled()) {
    url += '&bufferTheme=true';
  }
  if (getIsStagingV2Enabled()) {
    url += '&staging=true';
  }
  return url;
}
function trackLifecycleAndDeletePostBodyWidget(res) {
  trackAppLifecycleTimestamp(COMBINED_EDIT_REQUEST_FINISHED);

  // HACK The post_body is a fake widget and should never be saved.
  // Deleting at the highest level possible to avoid inconsistencies
  if (res && res.content && res.content.widgets && res.content.widgets.post_body) {
    delete res.content.widgets.post_body;
  }
  return res;
}
function httpFetch(id, includeUsedModuleSchemas) {
  return http.get(getUrl(id, includeUsedModuleSchemas), {
    timeout: 30000
  });
}
export function fetch(id, includeUsedModuleSchemas = false) {
  trackAppLifecycleTimestamp(COMBINED_EDIT_REQUEST_STARTED);
  const earlyRequest = getEarlyRequesterResultPromise(`content-${id}`);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => httpFetch(id, includeUsedModuleSchemas)) : null;
  const contentPromise = earlyRequestWithRetry || httpFetch(id, includeUsedModuleSchemas);
  return contentPromise.then(trackLifecycleAndDeletePostBodyWidget);
}
export function fetchPageCss(id, themePresetParams) {
  const shouldUseBufferedThemeSettings = getIsUniversalThemeEditorEnabled();
  const query = shouldUseBufferedThemeSettings ? Object.assign({
    buffer_theme: true
  }, themePresetParams) : {};
  if (getIsStagingV2Enabled()) {
    query.staging = true;
  }
  return http.get(getCssAssetsUrl(id), {
    query
  });
}